import {Keycode} from "../../constants/index";
import Slideshow from "../../classes/Slideshow";
import {Lightbox} from "../../classes/Lightbox";

export const initStories = () => {

	const components = document.querySelectorAll( 'section.stories' );

	if ( components.length ) {
		components.forEach( ( component ) => {

			let stories_info = JSON.parse( component.getAttribute( 'data-stories' ).replace( '},]', '}]' ) );
			const categories_container = component.querySelector( 'ul.cards' );
			const categories = Array.from( categories_container.querySelectorAll( 'button[data-category]' ) );
			const categories_info = {};
			let category, category_groups, current_story, current_timeline, duration, start_timestamp, stories, story_id, story_timeout, timeline_count, timeline_interval, timelines, timestamp, watching_new, storySlider, slide, isPaused, timeline_width, duration_passed, passed_width;
			
			/* Структуры для сортировки просмотренных сторис */
			let currentCategoriesOrder = {};
			let sortedDataCategories = [];

			const defineDuration = ( category, id ) => {

				const durationKeepers = timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == id );

				let durations = [];
				
				durationKeepers.forEach( ( item ) => {
					durations.push( item.getAttribute( 'data-duration' ));
				}); 

				if ( !durations[0] )
				{
					duration = 5000;
				}
				else
				{
					duration = durations[0];
				}

				return duration;
			}
				
			const hidePreviousStory = ( direction ) => {
				hideStory( direction, category, story_id );

				const previous_story = current_story - 1;

				if ( !stories_info[previous_story] )
				{
					return;
				}

				hideStory( direction, stories_info[previous_story].category, stories_info[previous_story].id );
			}

			const hideStory = ( direction, category, id ) => {
				category_groups = [...category_groups].filter(  group => group.getAttribute( 'data-category' ) == category );

				category_groups.forEach( ( item ) => {
					item.classList.remove( 'show', 'prev', 'next' );
				});			

				[...stories].filter( story => story.getAttribute( 'data-category' ) == category && story.getAttribute( 'data-story' ) == id ).forEach( ( item ) => {
					item.classList.remove( 'playing' );
				});

				timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == id ).forEach( ( item ) => {
					item.querySelectorAll( 'span' ).forEach( ( span ) => {
						span.parentNode.removeChild( span );
					});
				});
			
				if ( direction > 0 )
				{
					timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == id ).forEach( ( item ) => {
						item.classList.add( 'played' );
					});  
				}
				else
				{
					timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == id ).forEach( ( item ) => {
						item.classList.remove( 'played' );
					});  
				}
			}

			const isRequested = ( item, index ) => {
				current_story = index;
				story_id = item.id;
		
				return item.category === category && ( !watching_new || !item.seen );
			}

			const markSeenStories = () => {
				if ( watching_new )
				{
					stories_info.forEach( ( it, i ) =>  {
						if ( it.seen )
						{
							timelines.filter( tline => tline.getAttribute( 'data-category' ) == it.category && tline.getAttribute( 'data-story' ) == it.id ).forEach( ( item ) => {
								item.classList.add( 'played' );
							});
						}
					});
				}
			}

			const showNextStory = ( direction ) => {
				current_story = current_story + direction;

				if ( watching_new && direction > 0 )
				{
					/*
						Убрано пролистывание просмотренных сторис,
						просмотренные сторис отправляются в конец
					*/
					// while ( stories_info[current_story] && stories_info[current_story].seen )
					// {
					// 	current_story = current_story + direction;
					// }

					markSeenStories();
				}

				if ( stories_info[current_story] )
				{
					category = stories_info[current_story].category;
					story_id = stories_info[current_story].id;
					showStory( category, story_id, current_story );
					stories_info[current_story].seen = true;

					slide = stories_info[current_story].slideIndex - 1;

					if ( slide == 0 && direction == -1 )
					{
						document.querySelectorAll( 'div.lightbox.stories ul.slides > li' )[1].classList.remove( 'current' );
						storySlider._changeSlide( slide );
					}

					if ( slide > 0 )
					{
						storySlider._changeSlide( slide );
					}
				}
				else
				{
					if ( document.querySelectorAll( 'div.lightbox' ).length )
					{
						Lightbox.close();
					}
				}
			}

			const showStory = ( category, id, current, passed ) => {
				let duration = defineDuration( category, id );

				if ( passed )
				{
					duration = duration - ( duration * passed / 100 );
					passed_width = `${passed}%`;
				}
				else
				{
					passed_width = 0;
				}

				clearTimeout( story_timeout );
				story_timeout = setTimeout( step, duration );	

				if ( !current )
				{
					slide = getIndex( category ) - 1;
					storySlider._currentSlide = storySlider._slides[0];
					storySlider._setCurrentSlide( slide );
					storySlider._changeSlide( slide );
				}

				document.querySelectorAll( 'ul.story-buttons' ).forEach( ( node ) => {
					node.classList.remove( 'paused' );
				});

				if ( ![...stories].filter( story => story.getAttribute( 'data-category' ) == category && story.getAttribute( 'data-story' ) == id ).length )
				{
					if ( document.querySelectorAll( 'div.lightbox' ).length )
					{
						Lightbox.close();
					}

					return;
				}

				[...stories].filter( story => story.getAttribute( 'data-category' ) == category && story.getAttribute( 'data-story' ) == id ).forEach ( ( item ) => {
					item.classList.add( 'playing' );
				});

				timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == id ).forEach( ( item ) => {
					item.appendChild( document.createElement( 'span' ));
					current_timeline = item;
					item.querySelectorAll( 'span' ).forEach( ( span ) => {
						span.animate( [{ width: passed_width }, { width: '100%' }], { duration: duration } );
					});
				});


				clearInterval( timeline_interval );
				timeline_count = 0;

				timeline_interval = setInterval( () => {
					if ( timeline_count < duration )
					{
						timeline_count++;
					}
					else
					{
						clearInterval( timeline_interval );
					}
				}, 10 );

				document.cookie = `stories_watched_${id}=${category}stories_watched_${id}; path=/; expires=${new Date( 2999, 5, 12 )}`;

				categories_info[category].count--;

				if ( categories_info[category].count === 0 )
				{
					categories.filter( cat => cat.getAttribute( 'data-category' ) == category ).forEach( ( item ) => {
						item.closest( 'li' ).classList.add( 'seen' );
					});
				}

				[...stories].filter( story => story.getAttribute( 'data-category' ) == category && story.getAttribute( 'data-story' ) == id ).forEach( ( item ) => {
					if ( item.querySelectorAll( 'video' ).length )
					{
						item.querySelectorAll( 'video' )[0].play();
					}
				});
			}

			const getIndex = ( cat ) => {
				for ( let item in stories_info )
				{
					if ( stories_info[item].category == cat )
					{
						return stories_info[item].slideIndex;
					}
				}
			}
			
			const isStoriesSliderOpen = () => {
				const stories_lightbox_slider = Lightbox.getLightbox();
				
				return stories_lightbox_slider && stories_lightbox_slider.classList.contains( 'stories' );
			};

			const step = () => {
				if ( isStoriesSliderOpen() )
				{
					hidePreviousStory( 1 );
					showNextStory( 1 );
				}
			}

			const switchStory = ( evt ) => {
				if ( timestamp === evt.timeStamp )
				{
					return;
				}

				timestamp = evt.timeStamp;

				let direction;

				if ( evt.target.classList.contains( 'prev' ) || evt.keyCode === Keycode.ARROW_LEFT )
				{
					direction = -1;
				} 
				else if ( evt.target.classList.contains( 'next' ) || evt.keyCode === Keycode.ARROW_RIGHT )
				{
					direction = 1;
				}

				if ( current_timeline.querySelector( 'span' )) {
					current_timeline.querySelector( 'span' ).style.maxWidth = 0;
				}
				hidePreviousStory( direction );
				showNextStory( direction );
			}

			const pauseStory = ( evt ) => {
				if ( evt.target.classList.contains( 'story-buttons' ) && !evt.target.classList.contains( 'paused' ) ) {

					start_timestamp = evt.timeStamp;
					clearTimeout( story_timeout ); 
					clearInterval( timeline_interval );

					timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == story_id ).forEach( ( item ) => {
						current_timeline = item;
						timeline_width = current_timeline.querySelector( 'span' ).offsetWidth;
					});

					current_timeline.removeChild( current_timeline.querySelector( 'span' ));
					current_timeline.appendChild( document.createElement( 'span' ));
					current_timeline.querySelector( 'span' ).setAttribute( 'style', `width: ${timeline_width}px` );
					duration_passed = Math.floor( timeline_width / current_timeline.offsetWidth * 100 );

					evt.target.classList.add( 'paused' );
				} 
				else if ( evt.target.classList.contains( 'story-buttons' ) && evt.target.classList.contains( 'paused' ) )
				{
					const current = evt.target.closest( 'ul.stories > li' );
					const cat = current.getAttribute( 'data-category' );
					const story = current.getAttribute( 'data-story' );
					showStory( cat, story, current_story, duration_passed );

					timelines.filter( tline => tline.getAttribute( 'data-category' ) == category && tline.getAttribute( 'data-story' ) == story_id ).forEach( ( item ) => {
						item.removeChild( item.querySelector( 'span' ));
					});
				}
			}

			const changeCategory = ( evt ) => {
				const _this = evt.target;

				const direction = _this.classList.contains( 'prev' ) ? -1 : 1;

				if ( !watching_new )
				{
					_this.querySelectorAll( 'ul.timelines li' ).forEach( ( child ) => {
						child.classList.remove( 'played' );
					});
				}

				document.querySelectorAll( 'div.lightbox.stories ul.slides > li' ).forEach( ( node ) => {
					node.classList.remove( 'current' );
				});
				
				hideStory( direction, category, story_id );
				markSeenStories();
				category = _this.getAttribute( 'data-category' );
				stories_info.find( isRequested );
				showStory( category, story_id );
				stories_info[current_story].seen = true;
			}

			categories.forEach( ( category ) => {
				categories_info[category.getAttribute( 'data-category' )] = {
					count: 0,
					seen: true
				};
			} );

			stories_info.forEach( ( item ) => {
				if ( !item.seen )
				{
					categories_info[item.category].count++;
					categories_info[item.category].seen = false;
				}
			} );

			Object.keys( categories_info ).forEach( ( item ) => {
				if ( categories_info[item].seen )
				{
					categories.filter( cat => cat.getAttribute( 'data-category' ) == item ).forEach( ( it ) => {
						it.closest( 'li' ).classList.add( 'seen' );
					});
				}
			});
			
			/* Сторис. Просмотренные сторис уходят в конец */
			const sortUnwatchedStories = () => {
				currentCategoriesOrder = {};
				sortedDataCategories = [];
				
				const categoryNodes = Array.from( categories_container.childNodes );
				categories_container.innerHTML = '';
				
				categoryNodes.sort((a,b) => {
					if ( (a.classList.contains( 'seen' ) && b.classList.contains( 'seen' )) || (!a.classList.contains( 'seen' ) && !b.classList.contains( 'seen' )) )
					{
						const originOrderA = parseInt( a.dataset.originCategoryIndex, 10 );
						const originOrderB = parseInt( b.dataset.originCategoryIndex, 10 );
				
						return originOrderA - originOrderB;
					}
				
					if ( a.classList.contains( 'seen' ) )
					{
						return 1;
					}
				
					return -1;
				});
				
				const fragment = new DocumentFragment();
				categoryNodes.forEach( ( node ) => {
					fragment.append( node );
				} );
				
				categories_container.append( fragment );
				
				/* Создаётся структура нового порядка сторис: категория => новый индекс */
				Array.from( categories_container.childNodes ).forEach( ( li, index ) => {
					const currentDataCategory = li.dataset.category;
					
					if ( currentDataCategory )
					{
						currentCategoriesOrder[currentDataCategory] = index + 1;
						sortedDataCategories.push(currentDataCategory);
					}
				} );
				
				/* Сортируется массив stories_info */
				Object.keys( stories_info ).forEach( ( key ) => {
					const currentCategory = stories_info[key].category;
					const newIndex = currentCategoriesOrder[String(currentCategory)];
					
					if ( currentCategory && newIndex )
					{
						stories_info[key].slideIndex = String(newIndex);
					}
				} );
				
				const new_stories_info = [];
				sortedDataCategories.forEach( ( category ) => {
					const currentStoriesPack = stories_info.filter( (story) => story.category === category );
					
					new_stories_info.push( ...currentStoriesPack );
				} );
				
				stories_info = new_stories_info;
			};
			
			sortUnwatchedStories();
			
			const formData = new FormData();
			formData.append( 'action', 'get-stories' );

			categories.forEach( ( cat ) => {
				cat.addEventListener( 'click', () => {
					window.fetch('/ajax/', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							"X-Requested-With": 'XMLHttpRequest',
						},
						body: formData,
					})
						.then(( response ) => response.json())
						.then(( data ) => {
							const renderedString = data.rendered;
							
							const tempContainer = document.createElement( 'div' );
							tempContainer.innerHTML = renderedString;
							
							sortedDataCategories.forEach( ( category ) => {
								const li = tempContainer.querySelector( `ul.slides > li[data-category="${category}"]` );
								
								if ( li )
								{
									li.parentElement.append( li );
								}
							} );
							
							Lightbox.open( tempContainer.innerHTML, null, 'stories' );
							Lightbox.addCloseCallback( sortUnwatchedStories );
							
							/* Отключает стандартное закрытие Lightbox, для удобства использования перетаскивания */
							Lightbox.getLightbox().addEventListener( 'click', ( evt ) => {
								if ( evt.target === Lightbox.getLightbox() )
								{
									evt.preventDefault();
									evt.stopPropagation();
									evt.stopImmediatePropagation();
								}
							} );
							
							let isMouseDownOnCloseArea = false;
							Lightbox.getLightbox().addEventListener( 'mousedown', ( evt ) => {
								if ( evt.target === Lightbox.getLightbox() )
								{
									isMouseDownOnCloseArea = true;
								}
							} );
							
							Lightbox.getLightbox().addEventListener( 'mouseup', ( evt ) => {
								if ( evt.target === Lightbox.getLightbox() && isMouseDownOnCloseArea )
								{
									isMouseDownOnCloseArea = false;
									
									Lightbox.close();
								}
							} );
							
							const stories_lightbox = document.querySelector( 'div.lightbox.stories' );
							let images_to_load = 0;
							let loaded_images = 0;
							category_groups = stories_lightbox.querySelectorAll( 'ul.slides > li[data-category]' );
							timelines = Array.from( stories_lightbox.querySelectorAll( 'ul.timelines li[data-category][data-story]' ) );
							stories = stories_lightbox.querySelectorAll( 'ul.stories li[data-category][data-story]' )
							category = cat.getAttribute( 'data-category' );
							watching_new = cat.closest( 'li' ).classList.contains( 'seen' ) ? false : true;
							stories_info.find( isRequested );
							markSeenStories();

							stories_lightbox.classList.add( 'loading' );

							stories_lightbox.querySelectorAll( 'img' ).forEach( ( item ) => {
								const image = new Image();
	
								image.src = item.getAttribute( 'src' );
								images_to_load++;
	
								image.addEventListener( 'load', () => {
									loaded_images++;
	
									if ( loaded_images === images_to_load )
									{
										stories_lightbox.querySelector( 'div.content' ).classList.add( 'ready', 'slideshow' );
										const storiesSlider = stories_lightbox.querySelector( 'div.slideshow' );
						
										if ( storiesSlider )
										{
											const bookmarksContainer = stories_lightbox.querySelector( 'ul.buttons' );
											const slidesContainer = stories_lightbox.querySelector( 'ul.slides' );
											const navsContainer = stories_lightbox.querySelector( 'ul.nav' );
							
											if ( bookmarksContainer || navsContainer)
											{
												storySlider = new Slideshow({
													slidesContainer,
													bookmarksContainer,
													navsContainer,
													autoWidth: true,
													storiesMode: true,
												});
											}
										}

										showStory( category, story_id );
										stories_info[current_story].seen = true;
										stories_lightbox.classList.remove( 'loading' );
									}
								});
							});	
							
							stories_lightbox.querySelectorAll( 'ul.story-buttons li' ).forEach( ( button ) => {
								button.addEventListener( 'click', ( evt ) => {
									switchStory( evt );
								});
							})

							document.addEventListener( 'keydown', ( evt ) => {
								if ( evt.keyCode === Keycode.ARROW_LEFT )
								{
									switchStory( evt );
								}

								if ( evt.keyCode === Keycode.ARROW_RIGHT )
								{
									switchStory( evt );
								}
							})
						})
						.catch((err) => {
							console.log(err);
						});
				}) 
			});

			// ***************

			const initScroll = () =>
			{
				let wasStarted = false;
				let isDetecting = false;
				let startX;
				let moveX;
				let shiftX;
				let startY;
				let moveY;
				let currentShift;
				let maxShift;

				const calculateMaxShift = () =>
				{
					const container_width = categories_container.offsetWidth;
					let shift = 0;

					categories.forEach( ( card ) => {
						shift += ( card.offsetWidth + parseInt( getComputedStyle( card.closest( 'li' ) ).marginRight ));
					});

					shift = shift > container_width ? shift - container_width : shift;
					
					shift > 0 ? categories_container.classList.add( 'grab' ) : categories_container.classList.remove( 'grab' );

					return shift;
				}

				const calculateCurrentShift = () =>
				{
					let shift = 0;

					shift = categories_container.hasAttribute( 'style' ) ? parseInt( categories_container.getAttribute( 'style' ).split( 'transform: translate3d(' )[1]) : 0

					return shift;
				}
		
				const isMouseEvent = ( type ) => /mouse/.test( type );
		
				const startHandler = (startEvt) => {
					if ( wasStarted )
					{
						return;
					}
		
					isDetecting = true;
		
					if ( isMouseEvent(startEvt.type) )
					{
						startEvt.preventDefault();
					}
		
					startX = isMouseEvent(startEvt.type) ? startEvt.clientX : startEvt.touches[0].clientX;
					startY = isMouseEvent(startEvt.type) ? startEvt.clientY : startEvt.touches[0].clientY;
							
					currentShift = calculateCurrentShift();

					categories_container.classList.add(`grabbing`);
				};

				const setElementShift = ( element, shift, unit = `px` ) =>
				{
					maxShift = calculateMaxShift();

					shift = shift <= -maxShift ? -maxShift : shift > 0 ? 0 : shift;

					element.style.transform = `translate3d(${shift}${unit}, 0, 0)`;
				}
		
				const moveHandler = ( moveEvt ) => {
					if ( !wasStarted && !isDetecting )
					{
						return;
					}
		
					moveX = isMouseEvent(moveEvt.type) ? moveEvt.clientX : moveEvt.touches[0].clientX;
					moveY = isMouseEvent(moveEvt.type) ? moveEvt.clientY : moveEvt.touches[0].clientY;
		
					if ( isDetecting )
					{
						if ( Math.abs(startX - moveX) >= Math.abs(startY - moveY))
						{
							moveEvt.preventDefault();
		
							wasStarted = true;
						}
		
						isDetecting = false;
					}
		
					if ( wasStarted )
					{
						moveEvt.preventDefault();

						shiftX = (moveX - startX) + currentShift;

						categories_container.classList.add(`no-transition`);
						
						setElementShift( categories_container, shiftX );
					}
				};
		
				const endHandler = (endEvt) => {
					categories_container.classList.remove(`grabbing`);
		
					if ( !wasStarted || isDetecting )
					{
						return isDetecting = false;
					}
		
					endEvt.preventDefault();
		
					categories_container.classList.remove(`no-transition`);
				
					wasStarted = false;
		
					if ( isMouseEvent(endEvt.type) )
					{
						categories_container.addEventListener(`click`, (evt) => evt.preventDefault(), {once: true});
					}
				};

				calculateMaxShift();

				categories_container.addEventListener(`touchstart`, startHandler, {passive: true});
				document.addEventListener(`touchmove`, moveHandler, {passive: false});
				document.addEventListener(`touchend`, endHandler, {passive: false});
		
				categories_container.addEventListener(`mousedown`, startHandler);
				document.addEventListener(`mousemove`, moveHandler);
				document.addEventListener(`mouseup`, endHandler);
			}

			initScroll();

			// *********************

			document.addEventListener( 'touchstart', pauseStory );
			document.addEventListener( 'touchend', pauseStory );
			document.addEventListener( 'click', pauseStory );

			document.addEventListener( 'click', ( evt ) => {

				if ( evt.target.tagName == 'LI' && evt.target.hasAttribute( 'data-category' ) && !evt.target.classList.contains( 'current' )) {

					changeCategory( evt ); 
				}
			});
		});
	}
}
